import { createV3Queries } from "@query/utils/createV3Queries";
import { accountsApi } from "@api";

export const queriesAccounts = createV3Queries("accountsApi", accountsApi);
